import { render, staticRenderFns } from "./PreguntasMover.vue?vue&type=template&id=bb00800a"
import script from "./PreguntasMover.vue?vue&type=script&lang=js"
export * from "./PreguntasMover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports